import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@ui/components/Button'
import { ContentBlock } from '@ui/components/ContentBlock/ContentBlock'
import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { CircleCloseIcon } from '@ui/icons/CircleClose.icon'

import { Box } from '@shared/components/Box'
import { FullScreenFooter } from '@shared/templates/FullScreenLayout'
import { FundingTemplate } from '@shared/templates/FundingTemplate'

export const DepositFailedContent: React.FC<{
  onTryAgain: () => void
  reason?: string | null
}> = ({ onTryAgain }) => {
  const { t } = useTranslation()
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <FundingTemplate contentRef={contentRef}>
      <Box flex direction='column' gap='x32' align='center' minHeight='100%'>
        <ContentBlock
          variant='voucher'
          icon={
            <FeatureIcon
              size='lg'
              icon={CircleCloseIcon}
              bg='surface-danger-high-em'
              color='text-white'
            />
          }
          title={t('Deposit Failed')}
          description={t('There was an issue processing your deposit. Please try again')}
        />
        <FullScreenFooter contentRef={contentRef}>
          <Button.Primary fullWidth size='lg' onClick={onTryAgain}>
            {t('Try again')}
          </Button.Primary>
        </FullScreenFooter>
      </Box>
    </FundingTemplate>
  )
}
